import { TransactionDetailOptionFormType } from '@/features/transaction_items/Detail/type';
import { useTranslation } from '@/i18n';
import { IconInfo, Label, Radio } from '@moneyforward/ap-frontend-components';
import { RadioChangeEvent } from 'antd';
import classNames from 'classnames';
import { FC, memo, useCallback, useMemo } from 'react';
import { Control, useController } from 'react-hook-form';
import styles from './TransactionDetailOptionForm.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  control: Control<TransactionDetailOptionFormType>;
};

export const OptionVisible: FC<Props> = memo(({ control }) => {
  const { t } = useTranslation();

  const options = useMemo(
    () => [
      {
        id: 'visible',
        label: t('transaction_items.detail.options.enabled'),
        value: 'true',
      },
      {
        id: 'invisible',
        label: t('transaction_items.detail.options.disabled'),
        value: 'false',
      },
    ],
    [t]
  );

  const { field } = useController({
    control,
    name: 'is_visible',
  });

  const handleChange = useCallback(
    (e: RadioChangeEvent) => {
      field.onChange(e.target.value === 'true');
    },
    [field]
  );

  return (
    <div className={cx(styles['row'])}>
      <Label htmlFor='is_visible'>
        <div className={cx(styles['bold'])}>
          {t('transaction_items.detail.options.enabled_disabled')}
        </div>
      </Label>
      <div>
        <Radio
          id='is_visible'
          testId='is_visible'
          options={options}
          value={String(field.value)}
          onChange={handleChange}
        />
        <div className={cx(styles['caption'])}>
          <IconInfo size={12} />
          <p>
            {t('transaction_items.detail.options.enabled_disabled_caption')}
          </p>
        </div>
      </div>
    </div>
  );
});
OptionVisible.displayName = 'OptionVisible';
